/**
 * 예약 상품 상세 정보 - PC
 */
$(function () {
    // ###########################################################
    // A. 변수 설정 영역
    // ###########################################################
    let isLoading = false;  //로딩 여부 (중복 요청 방지)

    const p_no = 517;
    let gubun = 'R';
    const res_type2 = 'all';

    let sang;
    let chkin;
    let chkout;
    let night = 1;
    let room_cnt = 1;
    let person;

    let min_person;  //뒷단에서 사용
    let max_person;  //뒷단에서 사용
    let room_name;   //뒷단에서 사용

    let origin_price = 0;  // 원래 가격 (화면 표시 용도)
    let basic_price = 0;  //콘도 기본 사용료 (몇박 & 객실수 & 인원 3개로 경정된 기본 콘도 사용료)
    let final_sum_price = 0;  //전체 합산 금액

    // 패키지 사용
    let pkgs_use = {
        /*
        "p42": {
            date: "2025-04-30",  //이용날짜
            total: {
                count: 2,
                price: 5000
            },
            items: {
                "d134": {
                    count: 1,
                    price: 2000
                },
                "d135": {
                    count: 1,
                    price: 3000
                }
            }
        }
        */
    };

    // ###########################################################
    // B. 헬프 함수 영역
    // ###########################################################

    /**
     * 체크인/체크아웃 날짜로 night 반환
     */
    function getNight(checkInDate, checkOutDate) {
        const inDate = new Date(checkInDate);
        const outDate = new Date(checkOutDate);

        // 날짜 차이 계산 (밀리초 -> 일수)
        const diffTime = outDate - inDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    /**
     * 달력에서 체크인, 체크아웃 날짜 확인
     *
     * 달력의 chkin, chkou을 확인해서 리턴
     */
    function confirmDate() {
        const $calendar = $('#cal_pc_detail .calendar');
        const $chkin = $calendar.find('.day.chkin');
        const $chkout = $calendar.find('.day.chkout');

        const startDate = $chkin.attr('data-dt') || '';
        const endDate = $chkout.attr('data-dt') || '';

        return [startDate, endDate];
    }

    /**
     * 초과 인원 포함 여부를 판단해서 base_price를 역산하고,
     * 변경된 투숙 인원 기준으로 금액을 재계산한다.
     *
     * @param {number} old_price 기존 금액 (초과 요금 포함 가능)
     * @param {number} old_person 기존 투숙 인원
     * @param {number} new_person 변경된 투숙 인원
     * @param {number} room_cnt 객실 수
     * @param {number} max_person 객실당 최대 인원
     * @returns {number} 변경된 인원 기준 최종 금액
     */
    function getNewBasePriceByPerson(old_price, old_person, new_person, room_cnt, max_person) {
        const allowed = room_cnt * max_person;

        // 1. 기존 초과 인원 계산
        let old_extra = 0;
        if (old_person > allowed) {
            old_extra = (old_person - allowed) * 30000;
        }

        // 2. base_price 역산
        const base_price = old_price - old_extra;

        // 3. 새 초과 인원 계산
        let new_extra = 0;
        if (new_person > allowed) {
            new_extra = (new_person - allowed) * 30000;
        }

        // 4. 최종 금액 = base_price + 새 초과 요금
        return base_price + new_extra;
    }

    /**
     * 객실 수 변경 시, 초과 인원 포함 여부 고려해 최종 금액 재계산
     *
     * @param {number} old_price 기존 금액 (초과 포함 가능)
     * @param {number} old_room_cnt 기존 객실 수
     * @param {number} new_room_cnt 변경된 객실 수
     * @param {number} person 현재 투숙 인원
     * @param {number} max_person 객실당 최대 인원
     * @returns {number} 최종 계산된 금액
     */
    function getNewBasePriceByRoomCnt(old_price, old_room_cnt, new_room_cnt, person, max_person) {
        const old_allowed = old_room_cnt * max_person;
        const new_allowed = new_room_cnt * max_person;

        // 1. 기존 초과 인원 계산 → 초과 요금 추정
        let old_extra = 0;
        if (person > old_allowed) {
            old_extra = (person - old_allowed) * 30000;
        }

        // 2. base_price 역산 (기존 객실 1개당 가격)
        const base_unit_price = (old_price - old_extra) / old_room_cnt;

        // 3. 새 초과 인원 계산
        let new_extra = 0;
        if (person > new_allowed) {
            new_extra = (person - new_allowed) * 30000;
        }

        // 4. 새 총 가격 = base 단가 × 새 객실 수 + 새 초과 요금
        return Math.round(base_unit_price * new_room_cnt + new_extra);
    }


    /**
     * B. 사용한 옵션 상세내역 문자열 반환
     */
    function getPackageSummaryText() {
        const parts = [];

        for (const pkgId in pkgs_use) {
            const pkg = pkgs_use[pkgId];
            const items = pkg.items;

            // items가 없거나 빈 객체면 건너뛰기
            if (!items || Object.keys(items).length === 0) continue;

            const pkgName = pkg.name;
            const totalPrice = addComma(pkg.total.price);

            const optTexts = [];
            for (const optId in items) {
                const item = items[optId];
                optTexts.push(`${item.name} ${item.count}매`);
            }

            const optionsSummary = optTexts.join(' + ');
            parts.push(`${pkgName} (${optionsSummary}) <span>${totalPrice}</span>원`);
        }

        return parts.join(' + ');
    }

    /**
     * B. 가격을 분리해서 출력 (단품금액, 봉사료, 세금)
     */
    function refresh_split_price(totalAmount, exec='print') {
        const round = (num) => Math.round(num);

        const final_calc = round(totalAmount / 1.21);                   // 객실단품금액
        const serve_price = round(final_calc * 0.1);                    // 봉사료
        const vat_price = round((final_calc + serve_price) * 0.1);     // 세금
        //const final_price = final_calc + serve_price + vat_price;      // 총합 (검증용)

        if (exec == 'print') {  //화면 출력
            $('#price_base').text(addComma(final_calc));
            $('#price_service').text(addComma(serve_price));
            $('#price_tax').text(addComma(vat_price));
        } else if (exec == 'get') {
            return {
                "price_base": addComma(final_calc),
                "price_service": addComma(serve_price),
                "price_tax": addComma(vat_price)
            }
        }
    }

    /**
     * B. 가격 refrash 및 화면 refrach
     */
    function refresh_about_price_all() {
        const totalObj = calculatePackageTotals();
        console.log(totalObj);

        const optTotalPrice = totalObj.total.price;
        const priceSum = optTotalPrice + basic_price;

        $('#price_option').text(addComma(optTotalPrice)); //객실설정: 추가옵션 상품금액
        $('#price_sum').text(addComma(priceSum));  //객실설정: 계

        if (optTotalPrice > 0) {  // 옵션 있는 경우
            $('#final_none_pkg_result').hide();
            $('#final_have_pkg_result').show();

            const basicPrice = addComma(basic_price);
            const pkgSummaryText = getPackageSummaryText();
            let final_pkg_detail_string = `오션투유리조트속초설악비치호텔앤콘도 <span>${basicPrice}</span>원 + ${pkgSummaryText}`;
            if(2 <= room_cnt) {
                final_pkg_detail_string += `<span> × ${room_cnt}객실</span>`;
            }

            $('#final_pkg_detail_string').html(final_pkg_detail_string);
            $('#final_pkg_price').text(addComma(priceSum));  //최종 결제금액

        } else { //옵션 없음
            $('#final_none_pkg_result').show();
            $('#final_have_pkg_result').hide();

            $('#final_no_sale_price').text(addComma(origin_price));
            $('#final_price').text(addComma(basic_price));
        }
    }

    /**
     * 패키지 리로딩
     */
    function reloadPkg() {
        $.ajax({
            url: '/ajax/pkgList',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: "517", chkin: chkin}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(response) {
                //패키지 HTML 세팅
                const pkgs = response.pkgs;
                let pkgHtml = pkgs.map(function(pkg) {
                    return `
                        <li class="pkg-li">
                            <div class="pkg-tit">
                                <input type="checkbox" id="${pkg.id}" value="${pkg.id}" data-pkg-name="${pkg.name}">
                                <label for="${pkg.id}">${pkg.name}</label>
                            </div>
                        </li>
                    `;
                }).join('');
                pkgHtml += `
                    <li class="pkg-prc">
                        <div class="prc">
                            <div class="tit">패키지 상품 금액</div>
                            <div class="num"><span id="pkg-total-price">0</span>원</div>
                        </div>
                    </li>
                `;

                $('#pkg-lists').empty();
                $('#pkg-lists').append(pkgHtml);
                pkgs_use = {};  //패키지 사용내역 초기화

            },
            error: function(xhr, status, error) {
                isLoading = false;
                alert('데이터를 불러오는 중입니다.');
            }
        });
    }


    /**
     * B. 몇박몇일 select box Option 반환
     */
    function getNightSelectOptionHtml(night, maxDay) {
        let html = '';
        for (let d = 1; d <= maxDay; d++) {
            let selected = (night == d) ? 'selected=""' : '';
            html += `<option value="${d}" ${selected}>${d}박</option>`;
        }

        return html;
    }

    /**
     * B. 객실개수&인원수 select box Option 반환
     */
    function getCntSelectOptionHtml(cnt, maxCnt) {
        let html = '';
        for (let n = 1; n <= maxCnt; n++) {
            let selected = (cnt == n) ? 'selected=""' : '';
            html += `<option value="${n}" ${selected}>${n}</option>`;
        }

        return html;
    }

    /**
     * B. 체크인, 체크아웃 날짜로 Select box 반화
     */
    function generateDateSelectHTML(dates, pkg_id, pkg_name) {
        const isRoomService = pkg_name && pkg_name.includes('룸서비스');
        const filteredDates = isRoomService ? dates.filter(date => {
            const d = new Date(date);
            const month = d.getMonth() + 1;
            if (month >= 7 && month <= 8) return true; // 7월~8월은 전일 선택 가능
            return d.getDay() !== 4; // 목요일 선택 불가
        }) : dates;
        let html = `<select class="select-use-date" data-pkg-id="${pkg_id}">`;
        filteredDates.forEach(date => {
            html += `<option value="${date}">${date}</option>`;
        });
        html += '</select>';
        return html;
    }

    /**
     * B. 금액 콤마 추가
     *
     * @param int amount
     * @reutrn string
     */
    function addComma(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    /**
     * B. 금액 콤마 제거
     *
     * @param string str
     * @return number
     */
    function delComma(str) {
        return Number(str.replace(/,/g, ''));
    }


    // ###########################################################
    // C. 객실 상세정보(Detail) 출력 관련
    // ###########################################################

    /**
     * C. 리스트 객실(콘도) 클릭 이벤트 처리
     *
     * 객실(콘도) 상세 정보 출력
     */
    $(document).on('click', '.book-product-click', function (){
        const $li = $(this);
        const $radio = $li.find('input[type="radio"]');

        if (!$radio.prop('checked')) {
            $('#book-detail-info').remove();  //기존 상세정보 삭제
            pkgs_use = {};  //사용 패키지 객체 초기화

            $radio.prop('checked', true); //라디오 선택 처리

            const data = getDataFromHtml($li);  //html(화면)에서 받는 데이터 세팅
            sang = data.sang;  //객실 ID 업데이트

            min_person = data.min_person;  //룸 최소 인원수
            max_person = data.max_person;  //룸 최대 인원수
            person = data.min_person;  //디폴트 최소 인원
            room_name = data.room_name;  //룸 이름
            chkin = data.chkin; //체크인
            chkout = data.chkout;  //체크아웃
            night = data.night;  //몇박
            origin_price = data.normal;  // 원래 가격 (화면 표시 용도)
            basic_price = data.price; //콘도 기본 사용료

            loadDetailData($li);  // 상세 정보 ajax 요청
        }
    });

    /**
     * C. 만실된 리스트 객실(콘도) 클릭 이벤트 처리
     */
    $(document).on('click', '.book-product-closed-click', function (){
        alert('예약마감된 객실입니다.');
        return;
    });

    /**
     * C. 상세 > 객실 설정 > 체크인/체크아웃 달력 변경 후 처리
     */
    $(document).on('click', '#btn-booking-choice-date-detail', function (){
        var dateArr = confirmDate();
        var chkin_new = dateArr[0];
        var chkout_new = dateArr[1];

        if (!chkout_new) {
            $('input[name="chkin"]').val(chkin);  //원복
            $('input[name="chkout"]').val(chkout); //원복
            alert('체크아웃 날짜가 선택되지 않았습니다.');
            return;
        }

        var night_new = getNight(chkin_new, chkout_new);

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 517, r_no: sang, chkin: chkin_new, night: night_new, cnt: room_cnt}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    $('input[name="chkin"]').val(chkin);  //원복
                    $('input[name="chkout"]').val(chkout); //원복
                    return;
                }

                night = night_new;      //x박 업데이트
                basic_price = R.price;  //가격 변경 적용
                origin_price = R.price; //같게 세팅
                chkout = R.chkout;  //체크아웃 업데이트
                chkin = chkin_new;  //체크인 업데이트

                pkgs_use = {};  //패키지 가격 초기화
                refresh_split_price(basic_price);  // 단품, 봉사료, 세금 금액 새로고침
                refresh_about_price_all(); // 화면 가격 새로고침 (단품, 봉사료, 세금 금액 제외)

                reloadPkg();
            },
            error: function(xhr, status, error) {
                alert('데이터를 불러오는 중입니다.');
            }
        });
    });

    /**
     * C. 상세> 객실 설정 > 몇박Select box 변경 시, 상세 정보 리로딩
     *
     * 몇박여부 변경 시, 모든 정보를 초기화 및 객실정보 New 로딩
     */
    $(document).on('change', '#select-night', function (){
        const night_upd = this.value;

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 517, r_no: sang, chkin: chkin, night: night_upd, cnt: room_cnt}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    $('#select-night').val(night);  //변경사항 복원
                    return;
                }

                night = night_upd;      //x박 업데이트

                basic_price = getNewBasePriceByPerson(R.price, min_person, person, room_cnt, min_person);
                origin_price = basic_price; //같게 세팅
                chkout = R.chkout;
                $('input[name="chkout"]').val(chkout);

                pkgs_use = {};  //패키지 가격 초기화
                refresh_split_price(basic_price);  // 단품, 봉사료, 세금 금액 새로고침
                refresh_about_price_all(); // 화면 가격 새로고침 (단품, 봉사료, 세금 금액 제외)

                reloadPkg();
            },
            error: function(xhr, status, error) {
                alert('데이터를 불러오는 중입니다.');
            }
        });
    });

    /**
     * C. 객실 상세정보 출력
     *
     * 화면 HTML에서 받는(IN) 데이터는 여기에서 설정
     */
    function getDataFromHtml($This) {
        return {
            'base_ts': $This.data('basets'),
            'night': $This.data('night'),
            'chkin': $This.data('chkin'),
            'chkout': $This.data('chkout'),
            'sang': $This.data('sang'),
            'person': $This.data('person'),
            'min_person': $This.data('min-person'),
            'max_person': $This.data('max-person'),
            'price': $This.data('price'),
            'normal': $This.data('normal'),
            'room_name': $This.data('room-name')
        }
    }

    /**
     * C. 객실 상세정보 출력
     *
     * 객실 상세 정보 HTML 출력
     * 특정 콘도의 맨 처음 객실정보, 패키지선택
     */
    function renderDetailHtml(R, $This) {
        const nightSelectOptionHtml = getNightSelectOptionHtml(night, 15); //몇박몇일 select box Option
        const roomCntSelectOptionHtml = getCntSelectOptionHtml(room_cnt, 15); //객실개수 select box Option
        const personCntSelectOptionHtml = getCntSelectOptionHtml(person, max_person); //인원수 select box Option

        const pkgs = R.pkgs;  //패키지 데이터 배열
        const pkgHtml = pkgs.map(function(pkg) {
            return `
                <li class="pkg-li">
                    <div class="pkg-tit">
                        <input type="checkbox" id="${pkg.id}" value="${pkg.id}" data-pkg-name="${pkg.name}">
                        <label for="${pkg.id}">${pkg.name}</label>
                    </div>
                </li>
            `;
        }).join('');

        const splitPrice = refresh_split_price(basic_price, 'get');  // 단품, 봉사료, 세금 금액 반환
        const price_base = splitPrice.price_base;
        const price_service = splitPrice.price_service;
        const price_tax = splitPrice.price_tax;

        const detailHtml = `
            <div class="prd-cnt" id="book-detail-info" style="display:block;">
                <div class="prd-select">
                    <div class="room-wrap">
                        <div class="select-tit"><div class="room">1 객실 설정</div></div>
                        <div class="room-tit">${room_name}</div>
                        <div class="room-cnt">
                            <div class="input-wrap">
                                <p>체크인</p>
                                <input name="chkin" value="${chkin}" readonly="" onclick="$('#cal_pc_detail').show()" class="btn-cal prd-chkin" data-type="show">
                                <select class="prd-night" id="select-night">
                                    ${nightSelectOptionHtml}
                                </select>
                            </div>
                            <div class="input-wrap">
                                <p>체크아웃</p><input name="chkout" value="${chkout}" readonly="" onclick="$('#cal_pc_detail').show()" class="btn-cal prd-chkout" data-type="show">
                            </div>
                            <div class="input-wrap">
                                <div class="input-box">
                                    <p>객실갯수</p>
                                    <select id="select-room-cnt">
                                        ${roomCntSelectOptionHtml}
                                    </select>
                                </div>
                                <div class="input-box">
                                    <p>투숙인원</p>
                                    <select id="select-person">
                                        ${personCntSelectOptionHtml}
                                    </select>
                                </div>
                            </div>
                            <div class="price-wrap">
                                <div class="prc-item">
                                    <div class="tit">객실단품금액</div>
                                    <div class="prc"><span id="price_base">${price_base}</span>원</div>
                                </div>
                                <div class="prc-item">
                                    <div class="tit">봉사료</div>
                                    <div class="prc"><span id="price_service">${price_service}</span>원</div>
                                </div>
                                <div class="prc-item">
                                    <div class="tit">세금</div>
                                    <div class="prc"><span id="price_tax">${price_tax}</span>원</div>
                                </div>
                                <div class="prc-item">
                                    <div class="tit">추가옵션 상품금액</div>
                                    <div class="prc"><span id="price_option">0</span>원</div>
                                </div>
                                <div class="prc-item">
                                    <div class="tit">계</div>
                                    <div class="prc"><span id="price_sum">${addComma(basic_price)}</span>원</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="package-wrap">
                        <div class="select-tit">
                            <div class="list">2 패키지 선택</div>
                            <div class="info">
                                3 패키지 안내
                                <img onclick="$('.prd-cnt').hide();" src="https://img.ocean2you.co.kr/go/i_close.png" alt="닫기" class="close-btn">
                            </div>
                        </div>
                        <div class="pkg-cnt">
                            <ul id="pkg-lists">
                                ${pkgHtml}
                                <li class="pkg-prc">
                                    <div class="prc">
                                        <div class="tit">패키지 상품 금액</div>
                                        <div class="num"><span id="pkg-total-price">0</span>원</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="prd-pay">
                    <div class="pay" id="final_none_pkg_result">
                        최종 결제금액<span class="sm">(VAT, 봉사료, 예약수수료 포함)</span>
                        <div class="prc sale">
                            <span class="num" id="final_no_sale_price">${addComma(origin_price)}</span>원
                        </div>
                        <div class="prc final">
                            <span class="num" id="final_price">${addComma(basic_price)}</span>원
                        </div>
                    </div>
                    <div class="total-pay" id="final_have_pkg_result" style="display:none;">
                        <div>
                            <div class="desc" id="final_pkg_detail_string">
                                오션투유리조트속초설악비치호텔앤콘도 <span>99,900원</span> + 불꽃놀이 패키지 (불꽃놀이(대) 1매 + 불꽃놀이(중) 1매) <span>45,500원</span>
                            </div>
                            <p>=</p>
                            <div class="total">
                                <div class="txt">최종 결제금액</div>
                                <div class="prc"><span class="num" id="final_pkg_price">145,400</span>원</div>
                                <div>(VAT, 봉사료, 예약수수료 포함)</div>
                            </div>
                        </div>
                    </div>
                    <a href="#" class="rsv-btn" id="btn-go-reservation">예약하기 <i class="bi bi-chevron-right"></i></a>
                </div>
            </div>
        `;

        $This.append(detailHtml);  // html 화면 삽입
    }

    /**
     * C. 객실 상세정보 출력
     *
     * 객실 상세정보 검색 Ajax 요청 처리
     */
    function loadDetailData($This) {
        if (isLoading) return; // 중복 로딩 방지
        isLoading = true;

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 517, r_no: sang, chkin: chkin, night: night, cnt: room_cnt}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                // 예약 불가능 할 경우 alert 및 페이지 객실 리스트 리로딩
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    location.reload();
                    return;
                }
            },
            error: function(xhr, status, error) {
                isLoading = false;
                alert('데이터를 불러오는 중입니다.');
                location.reload();
            }
        });

        $.ajax({
            url: '/ajax/pkgList',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: "517", chkin: chkin}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(response) {
                isLoading = false;

                pkgs_use = {};  //패키지 사용내역 초기화
                $('#book-detail-info').remove(); //기존의 객실정보 삭제

                if (response) {
                    renderDetailHtml(response, $This);  // 화면 출력
                }
            },
            error: function(xhr, status, error) {
                isLoading = false;
                alert('데이터를 불러오는 중입니다.');
                location.reload();
            }
        });
    }

    // ###########################################################
    // D. 패키지 옵션 화면 출력
    // ###########################################################

    /**
     * 패키지 이용날짜 변경 처리
     */
    $(document).on('change', '.select-use-date', function () {
        const pkg_id = $(this).data('pkg-id');
        let check_in = $('input[name="chkin"]')?.val();
        let check_out = $('input[name="chkout"]')?.val();

        pkgs_use[pkg_id].date = this.value;

        // 조식패키지의 경우 날짜 앞으로 당김
        if(pkg_id === 'p42' && check_out <= this.value) {
            pkgs_use[pkg_id].date = check_in;
        }
    });

    /**
     * D. 패키지 클릭 이벤트
     *
     * 해당 패키지의 옵션 세팅 및 화면 출력
     */
    $(document).on('change', '.pkg-li input[type="checkbox"]', function () {
        const $checkbox = $(this);
        const isChecked = $checkbox.prop('checked'); // 체크 상태 확인
        const $li = $checkbox.closest('.pkg-li');
        const pkg_id = this.value;
        const pkg_name = $checkbox.data('pkg-name');

        if (isChecked) {
            //체크 될 때의 로직
            loadPkgOptData($li, pkg_id, pkg_name);  // 패키지 옵션 정보 ajax 요청

        } else {
            // 체크 해제 될 때의 로직
            // 해당 패키지 사용내역 초기화
            if (pkgs_use[pkg_id]) {
                delete pkgs_use[pkg_id];  // 해당 패키지 삭제
            }
            $li.find('.pkg').remove();  //패키지 옵션 화면에서 삭제
            $li.find('.pkg-tit').removeClass('active');  //패키지 옵션 화면에서 삭제
            refresh_about_price_all();  //가격 관련 내용 전체적인 반영
        }
    });

    /**
     * D. 패키지 옵션 HTML 검색 및 출력
     *
     * 패키지 옵션 검색 Ajax 요청 처리
     */
    function loadPkgOptData($This, pkg_id, pkg_name) {
        if (isLoading) return; // 중복 로딩 방지
        isLoading = true;

        const postData = {
            "pkg_id": pkg_id,
            "p_no": p_no,
            "gubun": gubun,
            "res_type2": res_type2,
            "sang": sang,
            "chkin": chkin,
            "chkout": chkout,
            "night": night,
            "room_cnt": room_cnt,
            "person": person
        };

        $.ajax({
            url: '/ajax/pkgOptDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: postData,
            dataType: 'json',
            success: function(response) {
                isLoading = false;

                $This.find('.pkg-tit').addClass('active');  //옵션 활성화

                if (response) {
                    renderPkgOptlHtml(response, pkg_id, $This, pkg_name);  // 화면 출력
                }

                //해당 패키지에 이용날짜만 입력; 날짜만 있고 옵션이 없는 것은 아직 아무것도 선택하지 않은 상태 임.
                pkgs_use[pkg_id] = {date: chkin, name: pkg_name, total: { count: 0, price: 0, origin_price: 0, taxfree: 0 }, items: {} };
            },
            error: function(xhr, status, error) {
                isLoading = false;
                alert('데이터를 불러오는 중입니다.');
            }
        });
    }

    /**
     * D. 패키지 옵션 HTML 화면 출력
     */
    function renderPkgOptlHtml(R, pkg_id, $This, pkg_name) {
        const options = R.menu;  //패키지 옵션 데이터 배열
        //console.log(R);
        const dateSelectHtml = generateDateSelectHTML(R.date, pkg_id, pkg_name);

        const pkgOtpHtml = options.map(function(opt) {
            let normal = addComma(opt.normal);  //세일 전 가격
            let price = addComma(opt.price);  //현재 가격

            return `
                <div class="opt-wrap">
                    <div class="tit">${opt.name}</div>
                    <div class="prc">
                        <span>${normal}원</span>&nbsp;${price}원
                        <div class="num">
                            <span class="btn btn-pkgopt-del" data-opt-name="${opt.name}" data-taxfree="${opt.taxfree}" data-price="${opt.price}" data-origin-price="${opt.normal}" data-pkg-id="${pkg_id}" data-opt-id="${opt.id}" data-calc=-1>-</span>
                            <input type="text" name="opt_count" value="0" >
                            <span class="btn btn-pkgopt-add" data-opt-name="${opt.name}" data-taxfree="${opt.taxfree}" data-price="${opt.price}" data-origin-price="${opt.normal}" data-pkg-id="${pkg_id}" data-opt-id="${opt.id}" data-calc=1>+</span>
                        </div>
                    </div>
                </div>
            `;
        }).join('');

        const html = `
            <div class="pkg active">
                <div class="pkg-opt">
                    <div class="opt-date">
                        <div class="tit">이용날짜</div>
                        ${dateSelectHtml}
                    </div>
                    ${pkgOtpHtml}
                </div>
                <div class="pkg-info">
                    ${R.info}
                    <div class="btn-more" onclick="$('.infoPopup').show()">더보기<i class="bi bi-plus-circle-fill"></i></div>
                </div>
            </div>
        `;

        $This.append(html);  // html 화면 삽입
    }

    // ###########################################################
    // E. 패키지 옵션 추가/삭제(+/-)
    // ###########################################################

    /**
     * E. 패키지 옵션 추가(+) 이벤트 처리
     */
    $(document).on('click', '.btn-pkgopt-add', function () {
        const pkg_id = $(this).data('pkg-id');
        const opt_id = $(this).data('opt-id');
        const opt_name = $(this).data('opt-name');
        const price = $(this).data('price');
        const origin_price = $(this).data('origin-price');
        const taxfree = $(this).data('taxfree');
        const $num = $(this).closest('.num');
        const $input = $num.find('input[name="opt_count"]');
        let val = parseInt($input.val(), 10) || 0;

        val += 1;
        $input.val(val);

        addOption(pkg_id, opt_id, opt_name, price, origin_price, taxfree); //옵션 추가
        refresh_about_price_all(); //페이지 가격 새로고침
        console.log(pkgs_use);
    });


    /**
     * E. 패키지 옵션 삭제(-) 이벤트 처리
     */
    $(document).on('click', '.btn-pkgopt-del', function (){
        const pkg_id = $(this).data('pkg-id');
        const opt_id = $(this).data('opt-id');
        const price = $(this).data('price');
        const origin_price = $(this).data('origin-price');
        const taxfree = $(this).data('taxfree');
        const $num = $(this).closest('.num');
        const $input = $num.find('input[name="opt_count"]');
        let val = parseInt($input.val(), 10) || 0;

        if (val < 1) {
            return;
        }

        val -= 1;

        $input.val(val);
        removeOption(pkg_id, opt_id, price, origin_price, taxfree);  //옵션 삭제
        refresh_about_price_all(); //페이지 가격 새로고침
        console.log(pkgs_use);
    });

    /**
     * E. 패키지 옵션 추가(+)
     */
    function addOption(pkgId, optId, optName, price, origin_price, taxfree, date = null) {
        if (!pkgs_use[pkgId]) {
            pkgs_use[pkgId] = { date: date, name: null, total: { count: 0, price: 0, origin_price: 0, taxfree: 0 }, items: {} };
        }

        if (date) { // date 값이 있으면 추가
            pkgs_use[pkgId].date = date;
        }

        if (!pkgs_use[pkgId].items[optId]) {
            pkgs_use[pkgId].items[optId] = { name: optName, count: 0, price: 0, origin_price: 0, taxfree: 0 };
        }

        pkgs_use[pkgId].items[optId].count += 1;
        pkgs_use[pkgId].items[optId].price += price;
        pkgs_use[pkgId].items[optId].origin_price += origin_price;
        pkgs_use[pkgId].items[optId].taxfree += taxfree;

        pkgs_use[pkgId].total.count += 1;
        pkgs_use[pkgId].total.price += price;
        pkgs_use[pkgId].total.origin_price += origin_price;
        pkgs_use[pkgId].total.taxfree += taxfree;
    }

    /**
     * E. 패키지 옵션 삭제(-)
     */
    function removeOption(pkgId, optId, price, origin_price, taxfree) {
        if (pkgs_use[pkgId]?.items[optId]) {
            pkgs_use[pkgId].total.count -= 1;
            pkgs_use[pkgId].total.price -= price;
            pkgs_use[pkgId].total.origin_price -= origin_price;
            pkgs_use[pkgId].total.taxfree -= taxfree;

            if (pkgs_use[pkgId].items[optId].count > 1) {
                pkgs_use[pkgId].items[optId].count -= 1;
                pkgs_use[pkgId].items[optId].price -= price;
                pkgs_use[pkgId].items[optId].origin_price -= origin_price;
                pkgs_use[pkgId].items[optId].taxfree -= taxfree;
            } else {
                delete pkgs_use[pkgId].items[optId];
            }
        }
    }

    /**
     * E. 사용 패키지 합산 리턴
     *
     * {
     *   p42: { count: 2, price: 5000, origin_price: 6000, taxfree: 4000 },
     *   p99: { count: 3, price: 7000, origin_price: 8000, taxfree: 6000 },
     *   total: { count: 5, price: 12000, origin_price: 14000, taxfree: 10000 }
     * }
     */
    function calculatePackageTotals() {
        const result = {
            total: { count: 0, price: 0, origin_price: 0, taxfree: 0 }
        };

        for (const pkgId in pkgs_use) {
            const pkg = pkgs_use[pkgId];
            let pkgCount = 0;
            let pkgPrice = 0;
            let pkgOriginPrice = 0;
            let pkgTaxfree = 0;

            for (const optId in pkg.items) {
                const item = pkg.items[optId];
                pkgCount += item.count;
                pkgPrice += item.price;
                pkgOriginPrice += item.origin_price;
                pkgTaxfree += item.taxfree;
            }

            // 패키지별 합산 저장
            result[pkgId] = {
                count: pkgCount,
                price: pkgPrice,
                origin_price: pkgOriginPrice,
                taxfree: pkgTaxfree
            };

            // 전체 합산 누적
            result.total.count += pkgCount;
            result.total.price += (pkgPrice * room_cnt); // 패키지 객실 수가 2개 이상인 경우 총비용 합산을 위해 room_cnt 반영
            result.total.origin_price += pkgOriginPrice;
            result.total.taxfree += pkgTaxfree;
        }

        return result;
    }

    // ###########################################################
    // F. 객실 갯수 변경 시 처리
    // ###########################################################

    /**
     * F. 상세> 객실 설정 > 객실갯수 Select box 변경 시, 대응 가격 업데이트
     */
    $(document).on('change', '#select-room-cnt', function (){
        const room_cnt_upd = this.value;

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 517, r_no: sang, chkin: chkin, night: night, cnt: room_cnt_upd}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    $('#select-room-cnt').val(room_cnt);  //변경사항 복원
                    return;
                }

                room_cnt = room_cnt_upd;      //객실갯수 업데이트

                basic_price = R.price;
                origin_price = basic_price; //같게 세팅

                person = min_person;

                // 객실갯수 변경 시 대응되는 투숙인원 SelectBox 선택 가능한 갯수도 업데이트
                const maxSelectBoxPerson = max_person * room_cnt; //전체 투숙가능한 인원
                const personSelectOoption = getCntSelectOptionHtml(min_person, maxSelectBoxPerson);
                $('#select-person').empty();
                $('#select-person').append(personSelectOoption);

                //화면 새로고침
                refresh_about_price_all();  //화면 금액 새로고침
                refresh_split_price(basic_price);  //단품금액, 봉사료, 세금 새로고침
            },
            error: function(xhr, status, error) {
                alert('데이터를 불러오는 중입니다.');
            }
        });
    });

    // ###########################################################
    // G. 투숙인원 변경 시 처리
    // ###########################################################

    /**
     * G. 상세> 객실 설정 > 투숙인원 Select box 변경 시, 대응 가격 업데이트
     */
    $(document).on('change', '#select-person', function (){
        // 투숙인원 변경 시, 금액 계
        basic_price = getNewBasePriceByPerson(basic_price, person, this.value, room_cnt, min_person);
        origin_price = basic_price;

        person = this.value;

        refresh_about_price_all();  //화면 금액 새로고침
        refresh_split_price(basic_price);  //단품금액, 봉사료, 세금 새로고침
    });

    // ###########################################################
    // H. 예약하기 시 처리
    // ###########################################################

    /**
     * 패키지 옵션 유효여부 체크
     *
     * 패키지가 추가되었으면 최소 하나의 옵션이 있어야 true, 아니면 false
     */
    function validatePackageOptions() {
        const pkgKeys = Object.keys(pkgs_use);

        // 패키지가 하나도 없는 경우는 통과
        if (pkgKeys.length === 0) return true;

        for (const pkgId of pkgKeys) {
            const pkg = pkgs_use[pkgId];
            const items = pkg.items;

            // items가 없거나 비어있으면 실패
            if (!items || Object.keys(items).length === 0) {
                return false;
            }
        }

        // 모든 패키지에 옵션이 최소 1개 이상 존재
        return true;
    }

    /**
     * 예약하기 클릭 이벤트 처리
     */
    $(document).on('click', '#btn-go-reservation', function (){
        //패키지 옵션 펼친 후, 선택 안된 것이 있는지 체크
        console.log(pkgs_use);
        if (validatePackageOptions() == false) {
            alert('선택한 패키지에 대한 인원을 선택하세오.');
            return;
        }

        //전송 할 폼 데이터 세팅
        const $form = $('<form>', {
            method: 'POST',
            action: '/booking/reservation'  // 전송할 URL
        });

         // CSRF 토큰 추가
        $form.append($('<input>', {
            type: 'hidden',
            name: '_token',
            value: $('meta[name="csrf-token"]').attr('content')
        }));

        if (hasAnyValidPackage(pkgs_use)) {
            gubun = 'P';
        } else {
            gubun = 'R';
        }

        // 1. 일반 변수들 추가
        $form.append($('<input>', { type: 'hidden', name: 'fval_s', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'abr_val', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'rent_option', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'p_no', value: p_no }));
        $form.append($('<input>', { type: 'hidden', name: 'gubun', value: gubun }));
        $form.append($('<input>', { type: 'hidden', name: 'res_type2', value: res_type2 }));
        $form.append($('<input>', { type: 'hidden', name: 'sang', value: sang }));
        $form.append($('<input>', { type: 'hidden', name: 'hseldate', value: chkin }));
        $form.append($('<input>', { type: 'hidden', name: 'nseldate', value: chkout }));
        $form.append($('<input>', { type: 'hidden', name: 'night', value: night }));
        $form.append($('<input>', { type: 'hidden', name: 'room_cnt', value: room_cnt }));
        $form.append($('<input>', { type: 'hidden', name: 'person', value: person }));

        $form.append($('<input>', { type: 'hidden', name: 'min_person', value: min_person }));
        $form.append($('<input>', { type: 'hidden', name: 'max_person', value: max_person }));
        $form.append($('<input>', { type: 'hidden', name: 'room_name', value: room_name }));

        // 2. pkg_opt[] 배열 추가
        const pkg_opt = Object.keys(pkgs_use);
        $.each(pkg_opt, function(i, val) {
            $form.append($('<input>', { type: 'hidden', name: 'pkg_opt[]', value: val }));
        });

        // 3. 패키지 옵을 추가
        for (const pkgId in pkgs_use) {
            const pkg = pkgs_use[pkgId];

            // 1. date 필드 추가
            $form.append($('<input>', {
                type: 'hidden',
                name: `${pkgId}_date`,
                value: pkg.date
            }));

            // 2. items 내부 옵션 순회
            const items = pkg.items;
            for (const optId in items) {
                const opt = items[optId];

                // count
                $form.append($('<input>', {
                    type: 'hidden',
                    name: `person_${pkgId}_${optId}`,
                    value: opt.count
                }));

                // price
                $form.append($('<input>', {
                    type: 'hidden',
                    name: `person_${pkgId}_${optId}_price2`,
                    value: opt.price
                }));
            }
        }

        // 4. 합산 값 추가
        const totalPkgOptObj = calculatePackageTotals();  //패키지 옵션 합산 값

        const pkg_final_price = totalPkgOptObj.total.price; //패키지 현재 가격 총합
        const pkg_show_price = totalPkgOptObj.total.price; //패키지 현재 가격 총합
        const pkg_deposit_price = 0;
        const pkg_normal_price = totalPkgOptObj.total.origin_price; //패키지 세일전 가격 총합
        const pkg_opt_person = totalPkgOptObj.total.count; //사용된 옵션 개수
        const final_price = basic_price + totalPkgOptObj.total.price; //최종 리얼 가격
        const normal_price = basic_price + totalPkgOptObj.total.origin_price;  //콘도리얼가격 + 옵션 세일전 가격 총합
        const deposit_price = basic_price //콘도 리얼가격
        const show_price = basic_price; //콘도 리얼가격
        const taxfree = totalPkgOptObj.total.taxfree; //taxfree 세팅

        $form.append($('<input>', { type: 'hidden', name: 'pkg_final_price', value: pkg_final_price }));
        $form.append($('<input>', { type: 'hidden', name: 'pkg_show_price', value: pkg_show_price }));
        $form.append($('<input>', { type: 'hidden', name: 'pkg_deposit_price', value: pkg_deposit_price }));
        $form.append($('<input>', { type: 'hidden', name: 'pkg_normal_price', value: pkg_normal_price }));
        $form.append($('<input>', { type: 'hidden', name: 'pkg_opt_person', value: pkg_opt_person }));
        $form.append($('<input>', { type: 'hidden', name: 'final_price', value: final_price }));
        $form.append($('<input>', { type: 'hidden', name: 'normal_price', value: normal_price }));
        $form.append($('<input>', { type: 'hidden', name: 'deposit_price', value: deposit_price }));
        $form.append($('<input>', { type: 'hidden', name: 'show_price', value: show_price }));
        $form.append($('<input>', { type: 'hidden', name: 'taxfree', value: taxfree }));

        // 5. 패키지 객체 정보 그대로 json 문자열로 변환 후 전송
        const jsonStr = JSON.stringify(pkgs_use);
        $form.append($('<input>', { type: 'hidden', name: 'pkgs_use', value: jsonStr }));

        // 6. refer 추가 (모바일 할인여부를 빈값으로 추가)
        $form.append($('<input>', { type: 'hidden', name: 'refer', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'event_chk', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'event_sub', value: '' }));

        // 7. from npay 추가 (네이버페이 쿠폰 진입여부)
        const from_npay_val = $('#from_npay_val').val();
        $form.append($('<input>', { type: 'hidden', name: 'from_npay', value: from_npay_val }));

        $form.appendTo('body').submit();
    });

    /**
     * 패키지 유효여부 반환
     */
    function hasAnyValidPackage(packages) {
        for (const pkg of Object.values(packages)) {
            if (
                pkg.items &&
                Object.keys(pkg.items).length > 0 &&
                Object.values(pkg.items).some(item => item.count > 0)
            ) {
                return true; // 하나라도 유효하면 true 즉시 반환
            }
        }
        return false; // 전부 무효하면 false
    }

});
